<template>
  <div>
    <div
      class="mt-3"
      v-if="permohonan"
    >
      <div
        class="permohonan-item card mb-0"
        style="cursor:pointer"
        v-for="p in permohonan"
        :key="p.id_data_permohonan"
      >
        <div class="card-body">
          <div class="d-flex">
            <div class="permohonan-icon mr-3 text-center">
              <img :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+p.paket_layanan.layanan.icon">
            </div>
            <div
              class="row"
              style="flex:auto"
            >
              <div
                class="col-md-8"
                @click="lihatPermohonan(p)"
              >
                <h6>{{ p.paket_layanan.layanan.nama_layanan }}</h6>
                <small>
                  {{ p.paket_layanan.paket.nama_paket }}
                  <span
                    class="text-success"
                    v-if="p.is_form_online === 1"
                  >(Form Online)</span>
                  <span
                    class="text-warning"
                    v-if="p.is_form_online === 2"
                  >(Form Manual)</span>
                </small>
                <p class="mb-0">
                  <small class="text-muted">
                    Dibuat oleh
                    <span class="text-dark">
                      {{ (p.user_pembantu) ? p.user_pembantu.penduduk.nama_lengkap + ' (Operator Desa)' : p.penduduk.nama_lengkap }}
                    </span>

                    <span v-if="p.user_pembantu">
                      untuk <span class="text-dark">{{ p.penduduk.nama_lengkap }}</span> 
                    </span>
                    pada
                    <span class="text-dark">
                      {{ new Date(p.timestamp_status_0).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) + ' ' + p.timestamp_status_0.substr(11, 8) }}
                    </span>
                  </small>
                </p>
              </div>
              <div class="col-md-4 text-right">
                <ListPermohonanBadgeStatus
                  :role="namaRole"
                  :status="p.status"
                  :tahap="p.tahap"
                />
                
                <div
                  class="mt-3"
                  v-if="namaRole === 'Penduduk' || namaRole === 'Operator Desa' || namaRole === 'Kepala Desa'"
                >
                  <button
                    v-if="isShowTombolBatal(p)"
                    class="btn btn-link text-danger btn-sm"
                    @click="batalkanPermohonan(p)"
                    title="Batalkan Permohonan"
                  >
                    Batalkan
                  </button>
                  <button
                    v-if="isShowTombolHapus(p)"
                    class="btn btn-link text-danger btn-sm"
                    @click="hapusPermohonan(p)"
                    title="Hapus Permohonan"
                  >
                    Hapus
                  </button>
                </div>
                <!-- tombol hapus khsus admin -->
                <div
                  class="mt-3"
                  v-if="namaRole === 'Admin Laksita' || namaRole === 'Admin Jembrana'"
                >
                  <button
                    v-if="isShowTombolHapus(p)"
                    class="btn btn-link text-danger btn-sm"
                    @click="hapusPermohonan(p)"
                    title="Hapus Permohonan"
                  >
                    Hapus
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="permohonan.length === 0"
        class="card"
      >
        <div class="card-body">
          <div
            class="empty-state"
            data-height="200"
            style="height: 200px;"
          >
            <div class="empty-state-icon">
              <i class="fas fa-question" />
            </div>
            <h2>Tidak ada data</h2>
          </div>
        </div>
      </div>
      <div
        class="permohonan-item card mt-2"
        style="cursor:pointer"
        @click="$router.push({path: '/permohonan/buat-permohonan'})"
        v-if="namaRole === 'Penduduk'"
      >
        <div class="card-body">
          <p class="text-center">
            <i class="fa fa-plus mr-2" /> Buat Permohonan Baru
          </p>
        </div>
      </div>
    </div>
    <div
      class="mt-3 mb-3"
      v-else
    >
      <div
        class="permohonan-item card mb-0"
        v-for="p in 4"
        :key="p"
      >
        <div class="card-body">
          <div class="d-flex">
            <div class="permohonan-icon mr-3 text-center">
              <div class="content-loader" />
            </div>
            <div
              class="row"
              style="flex:auto"
            >
              <div class="col-md-8">
                <h6 class="content-loader">
                  Nama Permohonan
                </h6>
                <small class="content-loader">Nama Paket</small>
                <p class="mb-0 content-loader">
                  Tanggal dan Waktu Pengajuan
                </p>
              </div>
              <div class="col-md-4 text-right">
                <div>
                  <span class="content-loader">Belum Diajukan</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- pagination -->
    <div class="row">
      <div class="col-md-6">
        <p class="mt-3">
          Menampilkan {{ meta.from }} sampai {{ meta.to }} dari {{ meta.total }} permohonan
        </p>
      </div>
                  
      <div class="col-md-6 mt-3">
        <b-pagination
          v-model="meta.current_page"
          :total-rows="meta.total"
          :per-page="meta.per_page"
          align="right"
          @change="changePage"
          aria-controls="dw-datatable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ListPermohonanBadgeStatus from './ListPermohonanBadgeStatus.vue'

export default {
  components: {
    ListPermohonanBadgeStatus
  },
  data () {
    return {
      meta: {
        current_page: 1,
        per_page: 10,
        from: null,
        to: null,
        total: null
      }
    }
  },
  computed: {
    permohonan() {
      return this.$store.getters.getPermohonan
    },
    metaPermohonan () {
      return this.$store.getters.getMetaPermohonan
    },
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  props: {
    mode: {
      type: String,
      default: () => null
    }
  },
  created () {
    this.meta = this.metaPermohonan
  },
  methods: {
    lihatPermohonan(p) {
      // set parameter back to, supaya tahu tombol back diklik balik ke data permohonan atau riwayat input
      this.$store.commit('SET_BACK_TO', this.mode)

      if (this.namaRole === 'Penduduk') {
        if (p.status === 0) {
          this.$store.dispatch('showDataPermohonanPenduduk', p.id_data_permohonan)
        } else {
          this.$router.push({ path: `/permohonan/detail-permohonan/${p.id_paket_layanan}|${p.id_penduduk}|${p.timestamp_status_0}` })
        }
      } else if (this.namaRole == 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        if (p.status === 0) {
          this.$store.dispatch('showDataPermohonanPendudukByDesa', p.id_data_permohonan)
        } else {
          this.$router.push({ path: `/permohonan/detail-permohonan/${p.id_paket_layanan}|${p.id_penduduk}|${p.timestamp_status_0}` })
        }
      } else if (this.namaRole == 'Rumah Sakit') {
        if (p.status === 0) {
          this.$store.dispatch('showDataPermohonanPendudukByRumahSakit', p.id_data_permohonan)
        } else {
          this.$router.push({ path: `/permohonan/detail-permohonan/${p.id_paket_layanan}|${p.id_penduduk}|${p.timestamp_status_0}` })
        }
      } else {
        this.$router.push({ path: `/permohonan/detail-permohonan/${p.id_paket_layanan}|${p.id_penduduk}|${p.timestamp_status_0}` })
      }
    },
    isShowTombolBatal(p) {
      let isBisa = false
      if (p.status === 1 || p.status === 3 || p.status === 5 || p.status === 7 || p.status === 9 || p.status === 11) {
        if (this.namaRole === 'Penduduk') {
          if (!p.id_operator_pembantu) {
            isBisa = true
          }
        } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
          if (p.id_operator_pembantu) {
            // jika permohonan ini dibantu olehnya baru bisa dibatalkan
            if (p.id_operator_pembantu == this.$store.getters.getUser.id_user) {
              isBisa = true
            }

          }
        }
      }
      return isBisa
    },
    isShowTombolHapus(p) {
      let isBisaHapus = false
      if (p.status === 0 || p.status === 13) {
        if (this.namaRole === 'Penduduk') {
          if (!p.id_operator_pembantu) {
            isBisaHapus = true
          }
        } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
          if (p.id_operator_pembantu) {
            // jika permohonan ini dibantu olehnya baru bisa dia hapus
            if (p.id_operator_pembantu == this.$store.getters.getUser.id_user) {
              isBisaHapus = true
            }
          }
        }
      }
      if (this.namaRole === 'Admin Laksita' || this.namaRole === 'Admin Jembrana'){
        isBisaHapus = true
      }
      return isBisaHapus
    },
    batalkanPermohonan(p) {
      let textBatal = ''
      let dispatchBatal = ''

      if (this.namaRole === 'Penduduk') {
        textBatal = `Yakin ingin membatalkan permohonan ${p.paket_layanan.layanan.nama_layanan}? Tindakan ini bersifat final/permohonan tidak dapat diajukan kembali.`
        dispatchBatal = 'batalkanPermohonanPenduduk'
      } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        textBatal = `Yakin ingin membatalkan permohonan ${p.paket_layanan.layanan.nama_layanan} untuk ${p.penduduk.nama_lengkap}? Tindakan ini bersifat final/permohonan tidak dapat diajukan kembali.`
        dispatchBatal = 'batalkanPermohonanPendudukByDesa'
      }

      swal({
        title: 'Konfirmasi',
        text: textBatal,
        icon: 'warning',
        buttons: {
          cancel: 'Batal',
          ok: {
            text: 'Yakin, batalkan permohonan',
            value: 'ok',
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch(dispatchBatal, p.id_data_permohonan).then(res => {
            if (res.data.status) {
              swal({
                title: 'Berhasil',
                text: res.data.message,
                icon: 'success',
                buttons: 'Ok'
              })
              this.$emit('loadPermohonan')
            } else {
              swal({
                title: 'Gagal',
                text: res.data.message,
                icon: 'error',
                buttons: 'Ok'
              })
            }
          }).catch(err => {
            // console.log(err)
            switch (err.response.status) {
              case 500:
                this.$router.push({ path: '/500' })
                break;

              case 400:
                swal({
                  title: 'Gagal',
                  text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                  icon: 'error',
                  buttons: 'Ok'
                })
                break;

              default:
                swal({
                  title: 'Gagal',
                  text: err.response.data.message,
                  icon: 'error',
                  buttons: 'Ok'
                })
                break;
            }
          })
        }
      })
    },
    hapusPermohonan(p) {
      let textHapus = ''
      let dispatchHapus = ''

      if (this.namaRole === 'Penduduk') {
        textHapus = `Yakin ingin menghapus permohonan ${p.paket_layanan.layanan.nama_layanan}? Tindakan ini bersifat final/tidak dapat dibatalkan.`
        dispatchHapus = 'hapusPermohonanPenduduk'
      } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        textHapus = `Yakin ingin menghapus permohonan ${p.paket_layanan.layanan.nama_layanan} untuk ${p.penduduk.nama_lengkap}? Tindakan ini bersifat final/permohonan tidak dapat diajukan kembali.`
        dispatchHapus = 'hapusPermohonanPendudukByDesa'
      } else if (this.namaRole === 'Admin Laksita' || this.namaRole === 'Admin Jembrana') {
        textHapus = 'Yakin hapus permohonan?'
        dispatchHapus = 'hapusPermohonanPendudukByAdmin'
      }

      swal({
        title: 'Konfirmasi',
        text: textHapus,
        icon: 'warning',
        buttons: {
          cancel: 'Batal',
          ok: {
            text: 'Yakin, hapus permohonan',
            value: 'ok',
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch(dispatchHapus, p.id_data_permohonan).then(res => {
            if (res.data.status) {
              swal({
                title: 'Berhasil',
                text: res.data.message,
                icon: 'success',
                buttons: 'Ok'
              })
              this.$emit('loadPermohonan')
            } else {
              swal({
                title: 'Gagal',
                text: res.data.message,
                icon: 'error',
                buttons: 'Ok'
              })
            }
          }).catch(err => {
            // console.log(err)
            switch (err.response.status) {
              case 500:
                this.$router.push({ path: '/500' })
                break;

              case 400:
                swal({
                  title: 'Gagal',
                  text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                  icon: 'error',
                  buttons: 'Ok'
                })
                break;

              default:
                swal({
                  title: 'Gagal',
                  text: err.response.data.message,
                  icon: 'error',
                  buttons: 'Ok'
                })
                break;
            }
          })
        }
      })
    },
    changePage(val) {
      this.$emit('setCurrentPage', parseInt(val))
    }
  },
  watch: {
    metaPermohonan(newVal){
      this.meta = newVal
      console.log('newval meta', newVal)
    }
  }
}
</script>